import React from 'react';

const FreeFeatureItem: React.FC<{ title: string }> = ({ title }) => (
  <div className="flex flex-col items-center">
    <div className="rounded-full bg-primary/20 p-2 mb-4">
      <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <p className="text-gray-400 text-center">{title}</p>
  </div>
);

const FreeForEveryone: React.FC = () => {
  return (
    <section className="bg-dark-light py-16 px-4 rounded-3xl mx-4 md:mx-auto max-w-6xl -mt-10 mb-20">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-300 mb-3">
          ValetPe is 100% Free for Everyone
        </h2>
        <p className="text-center text-gray-400 mb-12">
          ...making Refunding a Completely Stress-Free Experience
        </p>
        
        <div className="grid grid-cols-3 gap-8">
          <FreeFeatureItem title="No Joining Fee" />
          <FreeFeatureItem title="No Transaction Fee" />
          <FreeFeatureItem title="No Hidden Charges" />
        </div>
        
        <div className="text-center mt-10 text-gray-400">
          Don't miss out on instant refunds and premium perks.
        </div>
      </div>
    </section>
  );
};

export default FreeForEveryone;